export default __webpack_public_path__ + "static/media/ic_close_wh.1ed7051a.svg";